var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('iframe',{staticClass:"iframe-kb",attrs:{"name":"iframeKibana","src":_vm.urlkibana,"height":"90%","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }